export { default as FncoPreMarketingSlot } from './FncoPreMarketingSlot';
